/** チャットのアイコン縁（月パスの期間中だけ。絵は art-src/chat-frames/norm：穴の中心と半径をそろえた 760×760） */
export const CHAT_FRAMES = [
  { id: 'frame-kinzakura', name: '金桜', file: 'ring-01-kinzakura.webp' },
  { id: 'frame-tsuki', name: '銀月', file: 'ring-02-tsuki.webp' },
  { id: 'frame-momiji', name: '紅葉', file: 'ring-03-momiji.webp' },
  { id: 'frame-nami', name: '青海波', file: 'ring-04-nami.webp' },
  { id: 'frame-take', name: '若竹', file: 'ring-05-take.webp' },
  { id: 'frame-kitsunebi', name: '狐火', file: 'ring-06-kitsunebi.webp' },
  { id: 'frame-ikazuchi', name: '雷', file: 'ring-07-ikazuchi.webp' },
  { id: 'frame-yuki', name: '雪華', file: 'ring-08-yuki.webp' },
  { id: 'frame-fuji', name: '藤', file: 'ring-09-fuji.webp' },
  { id: 'frame-oni', name: '鬼', file: 'ring-10-oni.webp' },
] as const;

export type ChatFrameId = typeof CHAT_FRAMES[number]['id'];
export const isChatFrame = (id: unknown): id is ChatFrameId => typeof id === 'string' && CHAT_FRAMES.some(f => f.id === id);
export const chatFrame = (id: unknown) => CHAT_FRAMES.find(f => f.id === id);
